import { IStampDutyCountry } from "../forms/types";
import { calculateStampDuty, ICalculateStampDutyParams } from "../calculateStampDuty";
import { trackEvent } from "../../../../../helpers/analytics";

export interface IGetChargesToShowParams {
  propertyValue: number | undefined;
  country: IStampDutyCountry | undefined;
  isFirstTimeBuyer: boolean | undefined;
  isOnlyProperty: boolean | undefined;
}
export interface IChargesAndDescription {
  description: string;
  value?: number;
}

const zeroCharges = 0;

export const getChargesAndDescriptionsToShow = (
  params: IGetChargesToShowParams,
) => {
  if (Object.values(params).some((param) => param === undefined)) {
    return zeroCharges;
  }

  try {
    trackEvent("Stamp Duty Calculator Charges Shown", {
      module: "Stamp Duty Calculator",
      action: "Charges calculated",
      property_value: params.propertyValue,
      country: params.country,
      is_first_time_buyer: params.isFirstTimeBuyer,
      is_only_property: params.isOnlyProperty,
    });
    const charges = calculateStampDuty(params as ICalculateStampDutyParams);
    return charges;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return zeroCharges;
  }
};
